module.exports = __webpack_public_path__ + "img/acknowledge.a68d4ced.png";